import React, { useState } from 'react';

const ImageWithSkeleton = ({ 
  src, 
  alt, 
  className = '', 
  aspectRatio = 'aspect-video',
  objectFit = 'object-cover',
  bgClass = 'bg-gray-100'
}) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [hasError, setHasError] = useState(false);

  return (
    <div className={`relative ${aspectRatio} ${className} overflow-hidden ${bgClass}`}>
      {/* Skeleton loader with shimmer animation */}
      {!isLoaded && !hasError && (
        <div className="absolute inset-0 bg-gradient-to-r from-gray-200 via-gray-300 to-gray-200 animate-shimmer bg-[length:200%_100%]">
        </div>
      )}
      
      {/* Actual image - use object-contain on mobile for better display */}
      <img
        src={src}
        alt={alt}
        className={`absolute inset-0 w-full h-full ${objectFit} md:${objectFit} transition-opacity duration-700 ${
          isLoaded ? 'opacity-100' : 'opacity-0'
        }`}
        style={{ objectPosition: 'center' }}
        onLoad={() => setIsLoaded(true)}
        onError={() => setHasError(true)}
        loading="lazy"
      />
      
      {/* Error state */}
      {hasError && (
        <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
          <div className="text-center">
            <svg className="w-12 h-12 mx-auto text-gray-400 mb-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
            </svg>
            <p className="text-gray-400 text-sm">Image unavailable</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageWithSkeleton;
